require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-sara-williams.json") })
        }
      }, "path---authors-sara-williams");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-sara-williams!./.cache/json/authors-sara-williams.json
// module id = 1335
// module chunks = 231608221292675